module.exports = __webpack_public_path__ + "static/media/DistribuicaoCumulativa.64c2c677.svg";